import HistoryList from "./history-list";

export default HistoryList;
